import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/cookie.png'


const _hoisted_1 = { id: "main" }
const _hoisted_2 = { class: "cookie-bar__top" }
const _hoisted_3 = { class: "cookie-bar__text" }
const _hoisted_4 = { class: "cookie-bar__description" }
const _hoisted_5 = { class: "cookie-bar__bottom" }
const _hoisted_6 = ["href"]

import config from "./config"
import dayjs from "dayjs"
import { useReCaptcha } from "vue-recaptcha-v3"
import VueCookieAcceptDecline from "vue-cookie-accept-decline"
import { onMounted, ref, useTemplateRef, watch } from "vue"
import { useRoute } from "vue-router"
import { useI18n } from "vue-i18n"
import { useDictionaryStore } from "./store/dictionary"
import ButtonComponent from "./components/ui/ButtonComponent.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
const { fetchDynamicConfig } = useDictionaryStore()
const { locale } = useI18n()

const cookiesDetailsUrl = ref(config.links.cookie)

const cookieRef = useTemplateRef<typeof VueCookieAcceptDecline>("cookie")

const langFromUrl = route.query.lang
const langFromLocaleStorage = localStorage.getItem("guest-charging_locale")
const langFromConfig = config.defaultLanguage
const languageToSet =
  (langFromUrl as string) || langFromLocaleStorage || langFromConfig

if (config.languages.includes(languageToSet)) {
  locale.value = languageToSet
  dayjs.locale(languageToSet)
}

watch(locale, (newLanguage: string) => {
  localStorage.setItem("guest-charging_locale", newLanguage)

  dayjs.locale(newLanguage)
})

fetchDynamicConfig()

const recaptcha = async () => {
  const recaptcha = useReCaptcha()

  if (recaptcha) {
    await recaptcha.recaptchaLoaded()
    recaptcha.instance.value?.hideBadge()
  }
}

const acceptCookie = () => {
  cookieRef.value?.accept()
}

onMounted(() => {
  recaptcha()
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view),
    (_unref(config).featureCookieBar)
      ? (_openBlock(), _createBlock(_unref(VueCookieAcceptDecline), {
          key: 0,
          ref: "cookie",
          "element-id": "cookie",
          "disable-decline": true,
          "transition-name": "fade"
        }, {
          message: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _cache[0] || (_cache[0] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("common.cookies.text")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("a", {
                href: cookiesDetailsUrl.value,
                target: "_blank",
                class: "cookie-bar__learn-more-link"
              }, _toDisplayString(_ctx.$t("common.cookies.detailBtn")), 9, _hoisted_6),
              _createVNode(ButtonComponent, {
                class: "btn-cookie",
                md: "",
                onClick: acceptCookie
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("common.cookies.acceptBtn")), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 512))
      : _createCommentVNode("", true)
  ]))
}
}

})